import leftct from "react";
import { SubHeading } from "../../components";

import { images } from "../../constants";
import "./Calender.css";

const Calender = () => (
  <div className="app__aboutus section__padding app__wrapper" id="calender">
    <h1 className="app__calender-h1">Studio Events</h1>

    <div className="app__aboutus-content_about">
      <div className="p__opensans grid_left">September</div>
      <div className="p__opensans grid_right ">School year lessons begin</div>
      <div className="p__opensans grid_left">Late October</div>
      <div className="p__opensans grid_right ">
        Performance parties for students
      </div>
      <div className="p__opensans grid_left">December</div>
      <div className="p__opensans grid_right ">Music Open House for families</div>
      <div className="p__opensans grid_left">Late December - Early January</div>
      <div className="p__opensans grid_right ">Holiday Vacation</div>
      <div className="p__opensans grid_left">February</div>
      <div className="p__opensans grid_right ">
        Presidents Week Break
      </div>
      {/* </div>
      <SubHeading title="2024" />
      <div className="app__aboutus-content_about"> */}
      <div className="p__opensans grid_left ">March</div>
      <div className="p__opensans grid_right ">Performance parties for students</div>
      <div className="p__opensans grid_left">April</div>
      <div className="p__opensans grid_right ">
        Spring Break
      </div>
      <div className="p__opensans grid_left">May/June</div>
      <div className="p__opensans grid_right ">Spring Recitals</div>
      <div className="p__opensans grid_left">June - July - August</div>
      <div className="p__opensans grid_right ">Lessons by Appointment</div>
      {/* <button type="button" className="custom__button">Know More</button> */}
    </div>
    {/* <div className="secondrow">
      <div className="p__opensans">June, July, and August, 2024</div>
    </div> */}
  </div>
);

export default Calender;
